import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import TagRegularDiagonalReport from './tag-regular-diagonal-report-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <TagRegularDiagonalReport {...validProps} />;
}

SvgComponent.iconName = 'tagRegularDiagonalReport';

export const TagRegularDiagonalReportIcon = svgIconWrapper(SvgComponent);
